<template>
  <MdPreview
    editorId="md_text"
    :modelValue="data"
    style="word-break: normal; text-align: start"
  />
</template>

<script>
import { defineComponent } from 'vue'
import { MdPreview } from 'md-editor-v3'
import 'md-editor-v3/lib/preview.css'

export default defineComponent({
  name: 'MD',
  components: {
    MdPreview,
  },
  props: {
    data: [Object, String, Array, Boolean],
  },
  mounted: () => {
    document.getElementById('md_text-preview').style.wordBreak = 'normal'
  },
})
</script>
